export default {
  message: {
    title: '',
    preferVisitRead: '',
    preferVisitListten: '',
    preferVisitComplete: 'Completa',
    preferVisitShort: 'Curta',
    preferVisitSignoguia: 'Signoguia',
    titleVisitType: 'Visites guiades',
    titleMenu: 'Menú',
    moreInfo:'Saber-ne més?',
    moreInfoNo: 'No',
    moreInfoYes:'Sí',
    downloadAudio: '(Descàrrega d\'àudios)',
    download: 'Descàrrega dels arxius',
    downloadVideo: '(Descàrrega de videos)',
    downloadSignoguia: 'Descàrrega dels arxius de video',
    errorDownload: 'Hi ha hagut un error en la descàrrega. Torna a intentar-ho',
    cancelDownload: 'Has canceldo la descarga.',
    retry: 'Reintentar',
    noConnection: 'No tines conexión a internet',
    titleMap: 'NUMMER AUSWÄHLEN',
    map: 'mapa.png',

    initDownload: 'Bitte warten Sie',
    endDownload: 'Download abgeschlossen. Viel Vergnügen!!',


    menuItems: [
        {
            img: '1a.jpg',
            imageMenu: '',
            title: '1 BEGRÜSSUNG     ',
            author: '',
            description: '',
            audio: '1.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '1a.jpg',
                    second: '0'
                },
                {
                    img: '1b.jpg',
                    second: '55'
                },
                {
                    img: '1a.jpg',
                    second: '140'
                },
                {
                    img: '1c.jpg',
                    second: '181'
                },
                {
                    img: '1a.jpg',
                    second: '211'
                },
                {
                    img: '1d.jpg',
                    second: '227'
                },
            ],
        },
        {
            img: '2a.jpg',
            imageMenu: '',
            title: '2 DIE FROHE BOTSCHAFT',
            author: '',
            description: '',
            audio: '2.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '2a.jpg',
                    second: '0'
                },
                {
                    img: '2b.jpg',
                    second: '11'
                },
                {
                    img: '2c.jpg',
                    second: '61'
                },
                {
                    img: '2d.jpg',
                    second: '79'
                },
                {
                    img: '2c.jpg',
                    second: '96'
                },
                {
                    img: '2e.jpg',
                    second: '109'
                },
                {
                    img: '2f.jpg',
                    second: '162'
                },
            ],
        },
        {
            img: '3a.jpg',
            imageMenu: '',
            title: '3 DAS KREUZ',
            author: '',
            description: '',
            audio: '3.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '3a.jpg',
                    second: '0'
                },
                {
                    img: '3b.jpg',
                    second: '32'
                },
                {
                    img: '3c.jpg',
                    second: '41'
                },
                {
                    img: '3d.jpg',
                    second: '74'
                },
                {
                    img: '3c.jpg',
                    second: '84'
                },
                {
                    img: '3e.jpg',
                    second: '126'
                },
                {
                    img: '3f.jpg',
                    second: '142'
                },
                {
                    img: '3g.jpg',
                    second: '225'
                },
                {
                    img: '3h.jpg',
                    second: '238'
                },{
                    img: '3i.jpg',
                    second: '257'
                },
                {
                    img: '3j.jpg',
                    second: '268'
                },
                {
                    img: '3k.jpg',
                    second: '286'
                },
                {
                    img: '3l.jpg',
                    second: '312'
                },
            ],
        },
        {
            img: '4a.jpg',
            imageMenu: '',
            title: '4 DIE EVANGELISTEN',
            author: '',
            description: '',
            audio: '4.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '4a.jpg',
                    second: '0'
                },
                {
                    img: '4b.jpg',
                    second: '96'
                },
                {
                    img: '4c.jpg',
                    second: '129'
                },
                {
                    img: '4d.jpg',
                    second: '149'
                },
                {
                    img: '4e.jpg',
                    second: '167'
                },
                {
                    img: '4b.jpg',
                    second: '177'
                },
            ],
        },
        {
            img: '5a.jpg',
            imageMenu: '',
            title: '5 DIE TAUFE',
            author: '',
            description: '',
            audio: '5.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '5a.jpg',
                    second: '0'
                },
                {
                    img: '5b.jpg',
                    second: '23'
                },
                {
                    img: '5c.jpg',
                    second: '35'
                },
                {
                    img: '5a.jpg',
                    second: '85'
                },
                {
                    img: '5d.jpg',
                    second: '114'
                },
                {
                    img: '5e.jpg',
                    second: '175'
                },
                {
                    img: '5f.jpg',
                    second: '243'
                },
                {
                    img: '5g.jpg',
                    second: '288'
                },
                {
                    img: '5c.jpg',
                    second: '319'
                },{
                    img: '5h.jpg',
                    second: '334'
                },
                {
                    img: '5i.jpg',
                    second: '342'
                },
                {
                    img: '5j.jpg',
                    second: '355'
                },
            ],
        },
        {
            img: 'a6.jpg',
            imageMenu: '',
            title: '6 DIE VERGEBUNG',
            author: '',
            description: '',
            audio: '6.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '6a.jpg',
                    second: '0'
                },
                {
                    img: '6b.jpg',
                    second: '21'
                },
                {
                    img: '6a.jpg',
                    second: '53'
                },
                {
                    img: '6c.jpg',
                    second: '137'
                },
                {
                    img: '6d.jpg',
                    second: '171'
                },
                {
                    img: '6c.jpg',
                    second: '188'
                },
            ],
        },
        {
            img: '7a.jpg',
            imageMenu: '',
            title: '7 DIE APOSTEL',
            author: '',
            description: '',
            audio: '7.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '7a.jpg',
                    second: '0'
                },
                {
                    img: '7b.jpg',
                    second: '28'
                },
                {
                    img: '7c.jpg',
                    second: '37'
                },
                {
                    img: '7d.jpg',
                    second: '48'
                },
                {
                    img: '7e.jpg',
                    second: '58'
                },
                {
                    img: '7a.jpg',
                    second: '76'
                },
                {
                    img: '7f.jpg',
                    second: '128'
                },
                {
                    img: '7g.jpg',
                    second: '178'
                },
                {
                    img: '7h.jpg',
                    second: '196'
                },
            ],
        },
        {
            img: '8a.jpg',
            imageMenu: '',
            title: '8 DIE EUCHARISTIE',
            author: '',
            description: '',
            audio: '8.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '8a.jpg',
                    second: '0'
                },
                {
                    img: '8b.jpg',
                    second: '67'
                },
                {
                    img: '8c.jpg',
                    second: '103'
                },
                {
                    img: '8d.jpg',
                    second: '113'
                },
            ],
        },
        {
            img: '9a.jpg',
            imageMenu: '',
            title: '9 DIE MESSE',
            author: '',
            description: '',
            audio: '9.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '9a.jpg',
                    second: '0'
                },
                {
                    img: '8a.jpg',
                    second: '33'
                },
                {
                    img: '9a.jpg',
                    second: '54'
                },
                {
                    img: '9b.jpg',
                    second: '86'
                },
                {
                    img: '9c.jpg',
                    second: '101'
                },
                {
                    img: '9d.jpg',
                    second: '125'
                },
                {
                    img: '9e.jpg',
                    second: '158'
                },
                {
                    img: '9f.jpg',
                    second: '189'
                },
                {
                    img: '9e.jpg',
                    second: '214'
                },
                {
                    img: '9c.jpg',
                    second: '246'
                }
            ]
        },
        {
            img: '10a.jpg',
            imageMenu: '',
            title: '10 GREGOR DER GROSSE',
            author: '',
            description: '',
            audio: '10.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '11a.jpg',
            imageMenu: '',
            title: '11 KALVARIENBERG ',
            author: '',
            description: '',
            audio: '11.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '11a.jpg',
                    second: '0'
                },
                {
                    img: '11b.jpg',
                    second: '62'
                },
                {
                    img: '11c.jpg',
                    second: '83'
                },
                {
                    img: '11d.jpg',
                    second: '92'
                },
                {
                    img: '11a.jpg',
                    second: '118'
                },
                {
                    img: '11e.jpg',
                    second: '296'
                },
                {
                    img: '11f.jpg',
                    second: '336'
                },
            ]
        },
        {
            img: '12a.jpg',
            imageMenu: '',
            title: '12 SCHWESTER TOD',
            author: '',
            description: '',
            audio: '12.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '12a.jpg',
                    second: '0'
                },
                {
                    img: '12b.jpg',
                    second: '171'
                },
            ]
        },
        {
            img: '13a.jpg',
            imageMenu: '',
            title: '13 MONSTRANZEN',
            author: '',
            description: '',
            audio: '13.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '13a.jpg',
                    second: '0'
                },
                {
                    img: '13b.jpg',
                    second: '85'
                },
                {
                    img: '13c.jpg',
                    second: '103'
                },
                {
                    img: '13d.jpg',
                    second: '123'
                },
                {
                    img: '13e.jpg',
                    second: '127'
                },
                {
                    img: '13f.jpg',
                    second: '135'
                },
                {
                    img: '13g.jpg',
                    second: '143'
                }
            ]
        },
        {
            img: '14a.jpg',
            imageMenu: '',
            title: '14 AVE MARIA',
            author: '',
            description: '',
            audio: '14.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '14a.jpg',
                    second: '0'
                },
                {
                    img: '2b.jpg',
                    second: '12'
                },
                {
                    img: '11d.jpg',
                    second: '17'
                },
                {
                    img: '14b.jpg',
                    second: '26'
                },
                {
                    img: '14a.jpg',
                    second: '55'
                },
                {
                    img: '14c.jpg',
                    second: '119'
                },
                {
                    img: '14d.jpg',
                    second: '145'
                },
                {
                    img: '14e.jpg',
                    second: '185'
                }
            ]
        },
        {
            img: '15a.jpg',
            imageMenu: '',
            title: '15 ERSTER VORRAUM',
            author: '',
            description: '',
            audio: '15.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '15a.jpg',
                    second: '0'
                },
                {
                    img: '15b.jpg',
                    second: '40'
                },
                {
                    img: '15c.jpg',
                    second: '68'
                },
                {
                    img: '15d.jpg',
                    second: '117'
                },
                {
                    img: '15b.jpg',
                    second: '154'
                },
                {
                    img: '15c.jpg',
                    second: '181'
                },
            ]
        },
        {
            img: '16a.jpg',
            imageMenu: '',
            title: '16 ZWEITER VORRAUM',
            author: '',
            description: '',
            audio: '16.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '16a.jpg',
                    second: '0'
                },
                {
                    img: '16b.jpg',
                    second: '120'
                },
            ]
        },
        {
            img: '17a.jpg',
            imageMenu: '',
            title: '17 THRONSAAL',
            author: '',
            description: '',
            audio: '17.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '17a.jpg',
                    second: '0'
                },
                {
                    img: '17b.jpg',
                    second: '75'
                },
                {
                    img: '17a.jpg',
                    second: '97'
                },
                {
                    img: '17c.jpg',
                    second: '110'
                },
                {
                    img: '17d.jpg',
                    second: '126'
                },
            ]
        },
        {
            img: '18a.jpg',
            imageMenu: '',
            title: '18 DER NUNTIUS',
            author: '',
            description: '',
            audio: '18.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '18a.jpg',
                    second: '0'
                },
                {
                    img: '18b.jpg',
                    second: '43'
                },
                {
                    img: '18c.jpg',
                    second: '50'
                },
                {
                    img: '18d.jpg',
                    second: '115'
                },
            ]
        },
        {
            img: '19a.jpg',
            imageMenu: '',
            title: '19 WOHNRAUM',
            author: '',
            description: '',
            audio: '19.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '19a.jpg',
                    second: '0'
                },
                {
                    img: '19b.jpg',
                    second: '38'
                },
                {
                    img: '19c.jpg',
                    second: '47'
                },
            ]
        },
        {
            img: '20.jpg',
            imageMenu: '',
            title: '20 ARBEITSZIMMER',
            author: '',
            description: '',
            audio: '20.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '20a.jpg',
                    second: '0'
                },
                {
                    img: '20b.jpg',
                    second: '40'
                },
                {
                    img: '20c.jpg',
                    second: '162'
                },
                {
                    img: '20d.jpg',
                    second: '208'
                },
                {
                    img: '20e.jpg',
                    second: '232'
                },
                {
                    img: '20f.jpg',
                    second: '247'
                },
                {
                    img: '20e.jpg',
                    second: '259'
                },
                {
                    img: '20g.jpg',
                    second: '289'
                },
            ]
        },{
            img: '21a.jpg',
            imageMenu: '',
            title: '21 SCHLAFZIMMER',
            author: '',
            description: '',
            audio: '21.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '21a.jpg',
                    second: '0'
                },
                {
                    img: '21b.jpg',
                    second: '20'
                },
                {
                    img: '21a.jpg',
                    second: '38'
                },
                {
                    img: '21c.jpg',
                    second: '46'
                },
                {
                    img: '21d.jpg',
                    second: '56'
                },
            ]
        },
        {
            img: '22a.jpg',
            imageMenu: '',
            title: '22 EMPFANGSSAAL',
            author: '',
            description: '',
            audio: '22.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '22a.jpg',
                    second: '0'
                },
                {
                    img: '22b.jpg',
                    second: '61'
                },
                {
                    img: '22c.jpg',
                    second: '72'
                },
                {
                    img: '22d.jpg',
                    second: '75'
                },
                {
                    img: '22e.jpg',
                    second: '83'
                },
                {
                    img: '22f.jpg',
                    second: '87'
                },
                {
                    img: '22g.jpg',
                    second: '90'
                },
                {
                    img: '22h.jpg',
                    second: '98'
                },
            ]
        },
        {
            img: '23a.jpg',
            imageMenu: '',
            title: '23 ABSCHIED',
            author: '',
            description: '',
            audio: '23.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '23a.jpg',
                    second: '0'
                },
                {
                    img: '23b.jpg',
                    second: '8'
                },
                {
                    img: '22h.jpg',
                    second: '29'
                },
                {
                    img: '23c.jpg',
                    second: '68'
                },
                {
                    img: '22h.jpg',
                    second: '146'
                },
            ]
        },
        {
            img: '24.jpg',
            imageMenu: '',
            title: 'Créditos',
            author: '',
            description: 'Guion, producción, diseño y programación: Trama Media.<br><br>Imágenes: Catedral de Segovia.<br><br>Imágenes adicionales: Trama Media.<br><br>Imágenes de archivo:<br>Dibujo de un helecho de Gerrit Willem Dijsselhof (1866-1924) (Álbum).<br>Lápida sepulcral paleocristiana (principios del siglo III). Museo de las Termas de Diocleciano en Roma (Álbum / E. Viader / Prisma).<br>San Pedro, grabado de Hendrick Goltzius (1558-1617) (Álbum / National Gallery of Art, Washington DC).<br>Piscina bautismal de la ermita de Nuestra Señora de las Vegas en Santiuste de Pedraz. © Fundación Santa María la Real / J.M. Rodríguez Montañés.<br>Copia de un calvario de Jan van Scorel (1495-1562) (Álbum / Alamy).<br>Monseñor Jesús Vidal, obispo de Segovia, en la procesión del Corpus de 2025.<br>Los obispos Gandásegui y Castro en las fiestas de San José de Calasanz de Jaca (1917). Foto de F. de las Heras (Álbum / Archivo ABC/ Francisco de las Heras Calvo).<br>San Agustín de Hipona, grabado a partir de un dibujo de Maarten de Vos (1532-1603). Wellcome Collection, Londres.<br><br>Sagrada Biblia: Versión oficial de la Confederación Episcopal Española.<br><br>Música:<br>Manuel Braulio Canales (1747-1786). Cuartetos de cuerda. LMG2038 y LMG2049.<br>Adrian Willaert (1490-1562). Magnificat sexti toni. Naxos 8.553.211.<br>Carlo Gesualdo (1566-1613). O Crux benedicta. Naxos 8.550.742.<br>Juan de Anchieta (1462-1523). Credo. Naxos 8.555.772.<br>Adorabo. Naxos 8.550.711.<br>Giovanni Pierluigi da Palestrina (1525-1594). Stabat mater. Naxos 8.550.836.<br>Josef Anton Bruckner (1824-1896). Tantum ergo. Naxos 8.550.956.<br>Josef Anton Brucker. Tota pulchra es Maria. Naxos 8.550.956.<br><br>Trama Media ha hecho todo lo posible por obtener las autorizaciones necesarias para todos los contenidos reproducidos en esta guía. No obstante, si desea formular alguna reclamación relativa a la propiedad intelectual, no dude en ponerse en contacto con nosotros.<br><br>Todos los derechos reservados.<br><br>',
            audio: '',
            visitType: '{all}',
            moreInfoItem: '',
            isCredits: true,

        }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/data/i18n/deutsch.js